import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_REGULAR } from '../../../constant/spacing';
import _FileList, { FileListItem } from '../FileList';

interface Props {
  files: FileReference[];
}

const FileListContainer: FC<Props> = ({ files }) => {
  const children =
    files.length >= 1 ? (
      <FileList>
        {files.map((file) => (
          <FileListItem file={file} key={file.id} />
        ))}
      </FileList>
    ) : (
      <Typography>
        <FormattedMessage id="creative_brief_detail.field.files.empty" />
      </Typography>
    );

  return children;
};

const FileList = styled(_FileList)`
  padding-bottom: ${SPACING_REGULAR};
`;

export default FileListContainer;
